mutation SetDripSequenceStartTrigger($input: StartTriggerSetInput!) {
    startTriggerSet(input: $input) {
        campaign {
            id
        }
    }
}
